import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";

interface LeaseDetailsState {
    data: LeaseDetailsResponse;
    loading: boolean;
    error: string | null;
}

interface LeaseDetailsResponse {
    message: string;
    result: LeaseDetails;
}

interface PropertyManager {
    firstName: string;
    lastName: string;
    emailId: string;
    company: string;
    role: string;
}

interface SecondaryPropertyManager {
    firstName: string;
    lastName: string;
    emailId: string;
    company: string;
    role: string;
}

interface AbstractStatus {
    isSelected : boolean;
    label: string;
    value: string;
}

interface SubjectToSLR {
    isSelected : boolean;
    label: string;
    value: string;
}
interface LeaseDetails {
    leaseId: number;
    leaseType: string;
    propertyName: string;
    propertyId: string;
    investmentId: string;
    investmentName: string;
    propertyManager: PropertyManager | null;
    secondaryPropertyManager: SecondaryPropertyManager | null;  
    leasePopupUpdateComments: string;
    tenantId: string;
    tenantName: string;
    leaspropertyManagerNameType: string;
    lastmodified: string;
    LastModifiedBy: string;
    createdBy: string;
    created: string;
    leaseCommencement: string | null;
    rentCommencement: string | null;
    expiration: string | null;
    nuveenSigningDate: string | null;
    requestorEmailAddress: string;
    isActive: string;
    unitNumber: string;
    unitSquareFootage: string;
    fileName: string;
    comments: string;
    leaseStatus: string;
    standardTenantName: string;
    naicS_CodeTenant: string;
    xmin: number;
    leaseActivatedDate: string;
    tenantContactAvailable: string;
    sustainabilityContactAvailable: string;
    abstractStatus:  AbstractStatus[];
    subjectToSLR:  SubjectToSLR[];
    teamMemberId: string;
    
}
// interface LeaseDetails {
//     leaseId: string;
//     leaseType: string;
//     propertyName: string;
//     investmentId: string;
//     investmentName: string;
//     propertyManager: PropertyManager;
//     secondaryPropertyManager: SecondaryPropertyManager;
//     propertyManagerName: string;
//     secondaryPropertyManagerName: string;
//     tenantId: string;
//     tenantName: string;
//     leaspropertyManagerNameeType: string;
//     lastmodified: string;
//     lastModifiedBy: string;
//     createdBy: string;
//     created: string;
//     leaseCommencement: string;
//     rentCommencement: string;
//     expiration: string;
//     nuveenSigningDate: string;
//     requestorEmailAddress: string;
//     isActive: string;
//     unitNumber: string;
//     unitSquareFootage: string;
//     fileName: string;
//     comments: string;
//     leaseStatus: string;
//     standardTenantName: string;
//     naicS_CodeTenant: string;
//     xmin: string;
//     leaseActivatedDate: string;
//     tenantContactAvailable: string;
//     sustainabilityContactAvailable: string;
//     abstractStatus: AbstractStatus[];
//     subjectToSLR: SubjectToSLR[];
//     teamMemberId: string;
    
// }

const initialState: LeaseDetailsState = {
    data: {
        message: "",
        result: {} as LeaseDetails
    },
    loading: false,
    error: null
};

export const getLeaseData = createAsyncThunk("getLeaseData", async (payload:any, {rejectWithValue}) => {
    try {
        var url = `${baseUrl}Leases/GetById/${payload}`;
        const response = await getApiCall<any>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})`||error.message);
    }
})


const leaseDataSlice = createSlice({
    name: 'leaseData',
    initialState,
    reducers: {
        // Define your other reducers here
    },
    extraReducers: (builder) => {
        builder.addCase(getLeaseData.pending, (state) => {
            state.loading = true;
        })
        .addCase(getLeaseData.fulfilled, (state, action: PayloadAction<LeaseDetailsResponse>) => {
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(getLeaseData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'something went wrong';
        })
    },
});

export default leaseDataSlice.reducer;